var map = {
	"./auth/auth.module": [
		"./src/app/auth/auth.module.ts"
	],
	"./dashboard/dashboard.module": [
		"./src/app/dashboard/dashboard.module.ts",
		"default~dashboard-dashboard-module~tasks-tasks-module",
		"default~dashboard-dashboard-module~messages-messages-module",
		"common",
		"dashboard-dashboard-module"
	],
	"./home/home.module": [
		"./src/app/home/home.module.ts",
		"home-home-module"
	],
	"./messages/messages.module": [
		"./src/app/messages/messages.module.ts",
		"default~dashboard-dashboard-module~messages-messages-module",
		"common",
		"messages-messages-module"
	],
	"./professional/professional.module": [
		"./src/app/professional/professional.module.ts",
		"default~professional-professional-module~profile-profile-module~tasks-tasks-module",
		"common",
		"professional-professional-module"
	],
	"./profile/profile.module": [
		"./src/app/profile/profile.module.ts",
		"default~professional-professional-module~profile-profile-module~tasks-tasks-module",
		"common",
		"profile-profile-module"
	],
	"./tasks/tasks.module": [
		"./src/app/tasks/tasks.module.ts",
		"default~professional-professional-module~profile-profile-module~tasks-tasks-module",
		"default~dashboard-dashboard-module~tasks-tasks-module",
		"common",
		"tasks-tasks-module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		var id = ids[0];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;